import {IServiceTypesResponseInt} from '../state/service-types-int'
import {IServiceTypesPayloadInt} from './payload'
import {get as HttpGet} from '@telstra-connect/utils/http/requests/get'
import {
  loadServiceTypesErrorInt,
  loadServiceTypesStartInt,
  loadServiceTypesSuccessInt,
} from '../actions/load-service-types-int'

export function loadServiceTypesInt(companyId: string) {
  return (dispatch, getState) => {
    dispatch(loadServiceTypesStartInt())
    return HttpGet<IServiceTypesPayloadInt>({
      url: `/networks-and-internet/v1/international/services/service-types`,
      customHeaders: {
        'company-id': companyId,
      },
      state: getState(),
    })
      .then((result) => {
        const response: IServiceTypesResponseInt = result
        dispatch(loadServiceTypesSuccessInt(response))
      })
      .catch((error) => {
        dispatch(loadServiceTypesErrorInt('Error loading while service types.'))
      })
  }
}
